module.exports = __webpack_public_path__ + "static/img/img_title_jp.738fc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_jp.png
// module id = ngdy
// module chunks = 1